import React, {useCallback, useEffect, useState} from 'react';
import {MRAppRoutes, useMatchedRoute} from '../../../router/routes';
import {sectionToType, useExecutionSetupList} from '../../../../store/executionSetup';
import {useModel} from '../../../../store/model';
import {Order, useGridState} from '../../../../store/grid';
import {useLastValidValue} from '../../../../hooks/useLastValidValue';
import {useToggleSelected} from '../../../../hooks/useToggleSelected';
import {ExecutionSetupDTO} from 'hemwb-api';
import TableWithSortAndPagination from '../../../core/TableWithSortAndPagination';
import DefaultPage from '../../../layout/common/DefaultPage';
import SubModelActionMenu from '../common/SubModelActionMenu/SubModelActionMenu';
import SubModelSectionHeader from '../common/SubModelSectionHeader/SubModelSectionHeader';
import SuspenseNull from '../../../core/Suspense/SuspenseNull';
import {subModelGridColumns} from './utils';

const SubModelList: React.FC = () => {
  const {modelUuid, section} = useMatchedRoute(MRAppRoutes.SUBMODEL_LIST);
  const type = sectionToType(section);
  const model = useModel(modelUuid);
  const list = useExecutionSetupList(modelUuid, type);
  const gridState = useGridState({orderBy: 'name', order: Order.ASC});
  const storedList = useLastValidValue(list);

  const {selected, toggleSelected} = useToggleSelected();
  const handleClickRow = useCallback(
    (row: ExecutionSetupDTO) => {
      toggleSelected(row.id);
    },
    [toggleSelected],
  );

  const [selectedSubModel, setSelectedSubModel] = useState<ExecutionSetupDTO>();
  useEffect(() => {
    if (selected) {
      const found = storedList?.find((o) => o.id === selected);
      if (found) {
        setSelectedSubModel(found);
        return;
      }
    }
    setSelectedSubModel(undefined);
  }, [selected, storedList]);

  return (
    <>
      <DefaultPage>
        <SuspenseNull>
          {model && section && (
            <>
              <SubModelSectionHeader model={model} section={section} title="Sub-model list" />
              <TableWithSortAndPagination<ExecutionSetupDTO>
                getRowId={(o) => o.id}
                rows={storedList || []}
                columns={subModelGridColumns}
                onClickRow={handleClickRow}
                isRowSelected={(o) => o?.id === selected}
                gridState={gridState}
                loading={!list}
                noResultsMessage="No SubModel was found"
              />
            </>
          )}
        </SuspenseNull>
      </DefaultPage>
      <SubModelActionMenu model={model} subModel={selectedSubModel} section={section} />
    </>
  );
};

export default SubModelList;
